const webWorker = () => {
  const worker: Worker = self as any; // eslint-disable-line no-restricted-globals
  const fetchVDPAssets = message => {
    const cacheBreaker = `?v=${new Date().getTime()}`;
    fetch(
      `${message.data.CVNA_APP_ASSETS_CDN}/merchui/_next/static/prefetch-manifest.json`,
      { cache: 'no-store' }
    )
      .then(res => res.json())
      .then(res => {
        const promises = res.map(path =>
          fetch(`${message.data.CVNA_APP_ASSETS_CDN}/merchui/${path}`)
        );

        return Promise.all(promises);
      })
      .then(() =>
        fetch(
          `${message.data.CVNA_APP_ASSETS_CDN}/spinner/standalone/64/latest/version.txt${cacheBreaker}`
        )
      )
      .then(res => res.text())
      .then(res =>
        fetch(
          `${message.data.CVNA_APP_ASSETS_CDN}/spinner/standalone/64/${res}/CarvanaReactSpinner.js`
        )
      )
      .then(() => {
        worker.postMessage('success');
      })
      .catch(e => {
        console.log('Failure in Web Worker: ', e);
      });
  };

  worker.addEventListener('message', message => {
    // To be extra cautious, this helps ensure that these requests
    // do not compete for bandwidth with the SRP requests
    setTimeout(() => {
      fetchVDPAssets(message);
    }, 2000);
  });
};

export default webWorker;
